import { cn } from "@design-system/utils";
import { cva, type VariantProps } from "class-variance-authority";
import * as React from "react";

const alertVariants = cva(
  "relative grid w-full grid-cols-[0_1fr] items-start gap-y-0.5 rounded-lg px-4 py-3 text-sm has-[>svg]:grid-cols-[calc(var(--spacing)*4)_1fr] has-[>svg]:gap-x-3 [&>svg]:size-4 [&>svg]:translate-y-0.5 [&>svg]:text-current",
  {
    variants: {
      semantic: {
        neutral:
          "bg-shape-neutral-filled-background text-shape-neutral-filled-foreground-default",
        critical:
          "bg-shape-critical-filled-background text-shape-critical-filled-foreground-default",
        warning:
          "bg-shape-warning-filled-background text-shape-warning-filled-foreground-default",
        success:
          "bg-shape-success-filled-background text-shape-success-filled-foreground-default",
        waiting:
          "bg-shape-waiting-filled-background text-shape-waiting-filled-foreground-default",
        active:
          "bg-shape-active-filled-background text-shape-active-filled-foreground-default",
      },
    },
    defaultVariants: {
      semantic: "neutral",
    },
  }
);

function Alert({
  className,
  semantic,
  ...props
}: React.ComponentProps<"div"> & VariantProps<typeof alertVariants>) {
  return (
    <div
      data-slot="alert"
      role="alert"
      className={cn(alertVariants({ semantic }), className)}
      {...props}
    />
  );
}

function AlertTitle({ className, ...props }: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="alert-title"
      className={cn(
        "col-start-2 line-clamp-1 min-h-4 font-medium tracking-tight",
        className
      )}
      {...props}
    />
  );
}

function AlertDescription({
  className,
  ...props
}: React.ComponentProps<"div">) {
  return (
    <div
      data-slot="alert-description"
      className={cn(
        "col-start-2 grid justify-items-start gap-1 text-sm opacity-90 [&_p]:leading-relaxed",
        className
      )}
      {...props}
    />
  );
}

export { Alert, AlertTitle, AlertDescription };
